var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "asc__showPage" }, [
    _c("div", { staticClass: "asc__showPage-times" }, [
      _c("i", {
        staticClass: "fas fa-times-circle",
        on: {
          click: function($event) {
            return _vm.closeQuick()
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "asc__showPage-container" },
      [
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { cols: "12" } }, [
              _c(
                "header",
                [
                  _c("Breadcrumb", {
                    attrs: { title: _vm.rowData.Description1 }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" })
                ],
                1
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { cols: "12" } }, [
              _c("section", [
                _c("span", [
                  _c("i", { staticClass: "fas fa-code" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("insert.loyaltyCategory.Code")) + ":")
                  ]),
                  _vm._v(" " + _vm._s(_vm.rowData.Code))
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "far fa-circle" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("insert.loyaltyCategory.Description1")) +
                        ":"
                    )
                  ]),
                  _vm._v(" " + _vm._s(_vm.rowData.Description1))
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "far fa-circle" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("insert.loyaltyCategory.MinValue")) + ":"
                    )
                  ]),
                  _vm._v(" " + _vm._s(_vm.rowData.MinValue))
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "far fa-circle" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("insert.loyaltyCategory.MaxValue")) + ":"
                    )
                  ]),
                  _vm._v(" " + _vm._s(_vm.rowData.MaxValue))
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "far fa-circle" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("insert.loyaltyCategory.CategoryTypeId")) +
                        ":"
                    )
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.rowData.CategoryType
                          ? _vm.rowData.CategoryType.Label
                          : "-"
                      )
                  )
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "far fa-circle" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("insert.loyaltyCategory.CalcTypeId")) + ":"
                    )
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.rowData.CalcType ? _vm.rowData.CalcType.Label : "-"
                      )
                  )
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "far fa-circle" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("insert.loyaltyCategory.LoyaltyPoint")) +
                        ":"
                    )
                  ]),
                  _vm._v(" " + _vm._s(_vm.rowData.LoyaltyPoint))
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "far fa-circle" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("insert.loyaltyCategory.FieldAnalysisId")) +
                        ":"
                    )
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.rowData.FieldAnalysis
                          ? _vm.rowData.FieldAnalysis.Label
                          : "-"
                      )
                  )
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "far fa-circle" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("insert.loyaltyCategory.ByFrequency")) + ":"
                    )
                  ]),
                  _vm._v(" " + _vm._s(_vm.rowData.ByFrequency))
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "fas fa-check" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("insert.loyaltyCategory.StatusId")) + ":"
                    )
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.rowData.Status ? _vm.rowData.Status.Label : "")
                  )
                ])
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-tabs",
          [
            _vm.rowData.CalcType && _vm.rowData.CalcType.Code === "SH"
              ? _c(
                  "b-tab",
                  {
                    attrs: {
                      title: _vm.$t("insert.loyaltyCategory.salesTarget")
                    }
                  },
                  [
                    _c(
                      "b-row",
                      { staticClass: "p-4" },
                      [
                        _c(
                          "b-card",
                          { staticClass: "col-12 asc__showPage-card" },
                          [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.ColumnNameDesc,
                                    "text",
                                    "insert.loyaltyCategory.ColumnName"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.ColumnValueDesc,
                                    "text",
                                    "insert.loyaltyCategory.ColumnValue"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.Unit,
                                    "object",
                                    "insert.loyaltyCategory.UnitId"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.Quantity,
                                    "text",
                                    "insert.loyaltyCategory.Quantity"
                                  )
                                )
                              }
                            })
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.rowData.CalcType && _vm.rowData.CalcType.Code === "SH"
              ? _c(
                  "b-tab",
                  {
                    attrs: {
                      title: _vm.$t("insert.loyaltyCategory.salesTargetQuota")
                    }
                  },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-card",
                              { staticClass: "m-3 asc__showPage-card" },
                              [
                                _c("NextDetailPanel", {
                                  attrs: {
                                    type: "get",
                                    items: _vm.loyaltyCatQuotasItems
                                  },
                                  model: {
                                    value: _vm.rowData.LoyaltyCatQuotas,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.rowData,
                                        "LoyaltyCatQuotas",
                                        $$v
                                      )
                                    },
                                    expression: "rowData.LoyaltyCatQuotas"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.rowData.CalcType &&
            _vm.rowData.CalcType.Code === "ANS" &&
            _vm.rowData.FieldAnalysis &&
            _vm.rowData.FieldAnalysis.Code !== ""
              ? _c(
                  "b-tab",
                  {
                    attrs: {
                      title: _vm.$t("insert.loyaltyCategory.analysisResult")
                    }
                  },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-card",
                              { staticClass: "m-3 asc__showPage-card" },
                              [
                                _c("b-table", {
                                  attrs: {
                                    fields: _vm.loyaltyCategoryFields,
                                    items: _vm.rowData.LoyaltyCategoryCrits,
                                    bordered: "",
                                    responsive: ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "head()",
                                        fn: function(data) {
                                          return [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(_vm.$t(data.label)) +
                                                "\n                "
                                            )
                                          ]
                                        }
                                      },
                                      {
                                        key: "cell(operations)",
                                        fn: function(row) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "text-center" },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      size: "sm",
                                                      variant: "success"
                                                    },
                                                    on: {
                                                      click: row.toggleDetails
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      class: row.detailsShowing
                                                        ? "fa fa-arrow-up"
                                                        : "fa fa-arrow-down"
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "insert.loyaltyCategory.details"
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      },
                                      {
                                        key: "row-details",
                                        fn: function(ref) {
                                          var item = ref.item
                                          return [
                                            _c("b-table", {
                                              attrs: {
                                                items:
                                                  item.LoyaltyCategoryCritDetails,
                                                fields: _vm.loyaltyQuestionFields.filter(
                                                  function(f) {
                                                    return (
                                                      f.key !== "operations"
                                                    )
                                                  }
                                                )
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "head()",
                                                    fn: function(data) {
                                                      return [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.$t(data.label)
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    2038535024
                                  )
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.rowData.CategoryType && _vm.rowData.CategoryType.Code === "DEG"
              ? _c(
                  "b-tab",
                  {
                    attrs: {
                      title: _vm.$t("insert.loyaltyCategory.questionChoice")
                    }
                  },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-card",
                              { staticClass: "m-3 asc__showPage-card" },
                              [
                                _c("NextDetailPanel", {
                                  attrs: {
                                    type: "get",
                                    items: _vm.loyaltyCategoryValuesItems
                                  },
                                  model: {
                                    value: _vm.rowData.LoyaltyCategoryValues,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.rowData,
                                        "LoyaltyCategoryValues",
                                        $$v
                                      )
                                    },
                                    expression: "rowData.LoyaltyCategoryValues"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.rowData.CalcType && _vm.rowData.CalcType.Code === "AKS"
              ? _c(
                  "b-tab",
                  {
                    attrs: {
                      title: _vm.$t("insert.loyaltyCategory.activityResult")
                    }
                  },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-card",
                              { staticClass: "m-3 asc__showPage-card" },
                              [
                                _c("NextDetailPanel", {
                                  attrs: {
                                    type: "get",
                                    items: _vm.loyaltyCategoryTasksItems
                                  },
                                  model: {
                                    value: _vm.rowData.LoyaltyCategoryTasks,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.rowData,
                                        "LoyaltyCategoryTasks",
                                        $$v
                                      )
                                    },
                                    expression: "rowData.LoyaltyCategoryTasks"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.rowData.CalcType && _vm.rowData.CalcType.Code === "SA"
              ? _c(
                  "b-tab",
                  {
                    attrs: {
                      title: _vm.$t("insert.loyaltyCategory.salesAnalysis")
                    }
                  },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-card",
                              { staticClass: "m-3 asc__showPage-card" },
                              [
                                _c("b-table", {
                                  attrs: {
                                    fields: _vm.loyaltyCategoryFields,
                                    items: this.rowData.LoyaltyCatSales,
                                    bordered: "",
                                    responsive: ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "head()",
                                        fn: function(data) {
                                          return [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(_vm.$t(data.label)) +
                                                "\n                "
                                            )
                                          ]
                                        }
                                      },
                                      {
                                        key: "cell(operations)",
                                        fn: function(row) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "text-center" },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      size: "sm",
                                                      variant: "success"
                                                    },
                                                    on: {
                                                      click: row.toggleDetails
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      class: row.detailsShowing
                                                        ? "fa fa-arrow-up"
                                                        : "fa fa-arrow-down"
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "insert.loyaltyCategory.details"
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      },
                                      {
                                        key: "row-details",
                                        fn: function(ref) {
                                          var index = ref.index
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "p-4 mt-2 nested-detail-panel"
                                              },
                                              [
                                                _c("h3", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "insert.loyaltyCategory.salesAnalysis"
                                                      )
                                                    )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("NextDetailPanel", {
                                                  attrs: {
                                                    type: "get",
                                                    items:
                                                      _vm.LoyaltyCatSalesDetailsItems
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.rowData
                                                        .LoyaltyCatSales[index]
                                                        .LoyaltyCatSalesDetails,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.rowData
                                                          .LoyaltyCatSales[
                                                          index
                                                        ],
                                                        "LoyaltyCatSalesDetails",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "rowData.LoyaltyCatSales[index].LoyaltyCatSalesDetails"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1694885254
                                  )
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-165199b7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-165199b7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LoyaltyCategory/get.vue
// module id = null
// module chunks = 